import _ from "lodash";

import FluxStore from "./FluxStore";

import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

// Define initial data points
let accounts = [],
	selected = null,
	lineItems = [],
	paging = null;

// Method to load accounts data from API
function loadAccounts(data, kebabAccountName, selectedId)
{
	if (kebabAccountName && selectedId)
	{
		console.debug("loadAccounts should not receive name and id.");
	}
	accounts = data;
	let selectedIndex = -1;
	accounts.forEach((account, index) => {
		const newKebabName = _.kebabCase(account.name);

		let indexOfName = accounts.map(a => a.kebabName).indexOf(newKebabName);
		if (indexOfName !== -1)
		{
			account.kebabName = newKebabName + "-" + account.id;
		}
		else
		{
			account.kebabName = newKebabName;
		}

		if (selectedIndex === -1)
		{
			if ((kebabAccountName && account.kebabName === kebabAccountName) ||
				(selectedId && account.id === selectedId))
			{
				selectedIndex = index;
			}
		}
	});
	if (selectedIndex >= 0)
	{
		selected = data[selectedIndex];
	}
	else
	{
		selected = null;
	}
}

// Method to set the currently selected account
function setSelected(index)
{
	if (index < 0)
	{
		selected = null;
	}
	else
	{
		selected = accounts[index];
	}
}

class AccountStore extends FluxStore
{
	getAccounts()
	{
		return accounts;
	}

	// Return selected Account
	getSelected()
	{
		return selected;
	}

	getLineItems()
	{
		return lineItems;
	}

	getPaging() {
		return paging;
	}
}

const accountStore = new AccountStore();

accountStore.dispatchToken = AppDispatcher.register((action) => {
	let index = -1; // index is used in several cases

	switch (action.actionType) {
		case AppConstants.RECEIVE_DATA:
			lineItems = [];
			paging = null;
			loadAccounts(action.accounts, action.kebabAccountName);
			break;

		case AppConstants.RELOAD_DATA:
			if (action.hasOwnProperty("accounts"))
			{
				loadAccounts(action.accounts, null, action.selectedAccountId);
			}
			else
			{
				// No-op
				return true;
			}
			break;

		case AppConstants.ACCOUNTS_RECEIVE_LINEITEMS:
			lineItems = action.lineItems;
			paging = action.paging;
			break;

		case AppConstants.SELECT_ACCOUNT:
			lineItems = [];
			paging = null;
			setSelected(action.data);
			break;

		case AppConstants.ACCOUNTS_SAVE_SUCCESS: {
			const account = action.account;
			index = accounts.map(t => t.id).indexOf(account.id);

			// This logic is safe here because we may have [cash] and [cash-<accountid>] but saving
			// [cash] will search the list and not see any [cash] so it will save correctly
			// Saving [cash-<accountid>] will search for [cash], see one and rename it
			const newKebabName = _.kebabCase(account.name);
			let indexOfName = accounts.map(a => a.kebabName).indexOf(newKebabName);
			if (indexOfName !== -1)
			{
				account.kebabName = newKebabName + "-" + account.id;
			}
			else
			{
				account.kebabName = newKebabName;
			}

			if (index !== -1)
			{
				accounts[index] = account;
			}
			else
			{
				index = accounts.length;
				accounts.push(account);
			}
			setSelected(index);
			break;
		}

		case AppConstants.ACCOUNTS_SAVE_FAILURE: {
			break;
		}

		case AppConstants.ACCOUNT_LINEITEM_SAVE_PENDING: // Optimistic update
		case AppConstants.ACCOUNT_LINEITEM_SAVE_SUCCESS: {
			const ids = lineItems.map(t => t.id);
			// Get the index of the ID if it is in the transactions grid
			index = ids.indexOf(action.lineItem.id);
			// Get the index of the lineItem with an undefined id because that was the optimistically added lineItem
			index = index === -1 ? ids.indexOf(undefined) : index;

			const lineItem = action.lineItem;
			const lineItemModel = {
				id: lineItem.id,
				date: lineItem.date,
				accountId: lineItem.accountId,
				amount: lineItem.amount,
				description: lineItem.description,
				categoryId: lineItem.categoryId,
				transactionId: lineItem.transactionId,
				transferAccountId: lineItem.transferAccountId,
				tags: lineItem.tags
			};

			if (index !== -1)
			{
				lineItems[index] = lineItemModel;
			}
			else if (action.lineItem.accountId === selected.id)
			{
				index = lineItems.length;
				lineItems.push(lineItemModel);
			}
			break;
		}

		// TODO: BA-152 on failure, remove lineItem, needs to be set back to editable state

		case AppConstants.ACCOUNT_LINEITEM_DELETE_PENDING:
			index = lineItems.map(t => t.id).indexOf(action.lineItem.id);
			if (index !== -1)
			{
				lineItems.splice(index, 1);
			}
			break;

			// TODO: BA-31: Reload lineItems on Delete Failure

		case AppConstants.ACCOUNT_TRANSACTION_SAVE_SUCCESS: {
			const transaction = action.transaction;
			const lineItemsToAdd = transaction.lineItems;
			const isSplit = lineItemsToAdd.length > 1;
			const newLineItemIds = lineItemsToAdd.map(li => li.id);
			const existingLineItems = lineItems.filter(li => li.transactionId === transaction.id).map(li => li.id);
			existingLineItems.forEach(lineItemId =>
			{
				if (newLineItemIds.indexOf(lineItemId) === -1)
				{
					// This line item was removed from the transaction
					lineItems.splice(lineItems.findIndex(li => li.id === lineItemId), 1);
				}
			});
			const lineItemIds = lineItems.map(li => li.id);
			lineItemsToAdd.forEach(lineItemToAdd =>
			{
				const lineItemModel = {
					id: lineItemToAdd.id,
					date: transaction.date,
					accountId: transaction.accountId,
					amount: lineItemToAdd.amount,
					description: lineItemToAdd.description,
					categoryId: lineItemToAdd.categoryId,
					transactionId: lineItemToAdd.transactionId,
					tags: lineItemToAdd.tags,
					splitTransaction: isSplit
				};
				// Get the index of the ID if it is in the transactions grid
				index = lineItemIds.indexOf(lineItemToAdd.id);

				if (index !== -1)
				{
					lineItems[index] = lineItemModel;
				}
				else
				{
					lineItems.push(lineItemModel);
				}
			});
			break;
		}

		default:
			return true;
	}

	// If action was responded to, emit change event
	accountStore.emitChange();
	return true;
});

export default accountStore;



// WEBPACK FOOTER //
// ./Components/stores/AccountStore.jsx